export enum ScreenSize {
  DESKTOP_L = 1394,
  DESKTOP = 1088,
  TABLET = 936,
  MOBILE = 578,
  MOBILE_S = 408,
}

// 1394 - infinity - DESKTOP_L
// 1088 - 1394 - DESKTOP
// 936 - 1088 - TABLET
// 578 - 936 - MOBILE
// 408 - 578 - MOBILE_S
// 0 - 408 - MOBILE_XS

export const padding = 40;
export const paddingMob = 18;
export const doublePadding = padding * 2;

export const device = {
  desktopL: `min-width: ${ScreenSize.DESKTOP_L + doublePadding}px`,
  desktop: `max-width: ${ScreenSize.DESKTOP_L + doublePadding}px`,
  tablet: `max-width: ${ScreenSize.DESKTOP + doublePadding}px`,
  mobile: `max-width: ${ScreenSize.TABLET + doublePadding}px`,
  mobileS: `max-width: ${ScreenSize.MOBILE + doublePadding}px`,
  mobileXS: `max-width: ${ScreenSize.MOBILE_S + doublePadding}px`,
};
